module.exports = {
	"id": "MR",
	"name": "Mauritania",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.003102,
			"5": 0.043428,
			"6": 0.037224,
			"7": 0.065142,
			"8": 0.027918,
			"9": 0.068244,
			"10": 0.006204,
			"11": 0.074448,
			"12": 0.037224,
			"13": 0.034122,
			"14": 0.06204,
			"15": 0.021714,
			"16": 0.024816,
			"17": 0.083754,
			"18": 0.018612,
			"19": 0.01551,
			"20": 0.006204,
			"21": 0.006204,
			"22": 0.03102,
			"23": 0.058938,
			"24": null,
			"25": 0.055836,
			"26": 0.040326,
			"27": 0.040326,
			"28": 0.037224,
			"29": 0.03102,
			"30": 0.009306,
			"31": 0.133386,
			"32": 0.009306,
			"33": 0.12408,
			"34": 0.040326,
			"35": 0.034122,
			"36": 0.034122,
			"37": null,
			"38": 0.027918,
			"39": 0.01551,
			"40": 0.021714,
			"41": 0.006204,
			"42": 0.167508,
			"43": 0.561462,
			"44": 0.034122,
			"45": 0.179916,
			"46": 0.099264,
			"47": 0.214038,
			"48": 0.111672,
			"49": 1.296636,
			"50": 0.130284,
			"51": 0.6204,
			"52": 0.428076,
			"53": 10.373088,
			"54": 2.726658,
			"55": 0.049632,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": 0.003102,
			"3": 0.024816,
			"4": 0.034122,
			"5": null,
			"6": 0.009306,
			"7": null,
			"8": 0.009306,
			"9": null,
			"10": 0.012408,
			"11": 0.024816,
			"12": 0.055836,
			"13": 0.024816,
			"14": 0.018612,
			"15": null,
			"16": 0.03102,
			"17": 0.04653,
			"18": 0.012408,
			"19": null,
			"20": 0.04653,
			"21": 0.04653,
			"22": 0.012408,
			"23": 0.006204,
			"24": 0.052734,
			"25": 0.009306,
			"26": 0.052734,
			"27": 0.021714,
			"28": 0.006204,
			"29": 0.021714,
			"30": 0.037224,
			"31": 0.012408,
			"32": 0.052734,
			"33": 0.021714,
			"34": 0.034122,
			"35": 0.027918,
			"36": 0.021714,
			"37": 0.037224,
			"38": 0.043428,
			"39": 0.043428,
			"40": 0.080652,
			"41": 0.037224,
			"42": 0.04653,
			"43": 0.446688,
			"44": 0.09306,
			"45": 0.071346,
			"46": 0.07755,
			"47": 0.580074,
			"48": 0.518034,
			"49": 4.12566,
			"50": 0.105468,
			"51": 0.009306,
			"52": null,
			"3.5": 0.009306,
			"3.6": 0.034122
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.003102,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": 0.003102,
			"20": null,
			"21": 0.003102,
			"22": 0.009306,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.006204,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.003102,
			"34": null,
			"35": null,
			"36": 0.037224,
			"37": 0.049632,
			"38": 0.012408,
			"39": 0.009306,
			"40": 0.378444,
			"41": 0.04653,
			"42": 0.006204,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.009306
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.003102,
			"6": null,
			"7": 0.006204,
			"8": 0.03102,
			"9": 0.018612,
			"10": 0.130284,
			"3.1": null,
			"3.2": null,
			"5.1": 0.006204,
			"6.1": null,
			"7.1": 0.003102,
			"9.1": 0.096162
		},
		"ios_saf": {
			"8": 0,
			"10": 2.58878321565,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0697647121149,
			"8.1-8.4": 0.1288873495,
			"9.0-9.2": 0.0614875428809,
			"9.3": 0.93807917985
		},
		"android": {
			"3": 0,
			"4": 0.288842609819,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0361053262274,
			"4.1": 1.04189655685,
			"4.2-4.3": 2.60474139212,
			"4.4": 5.97285253876,
			"4.4.3-4.4.4": 6.02443157623
		},
		"ie": {
			"6": 0.0124568503937,
			"7": 0.00934263779528,
			"8": 0.27716492126,
			"9": 0.0965405905512,
			"10": 0.112111653543,
			"11": 1.07440334646,
			"5.5": null
		},
		"op_mob": {
			"0": 0.879577300296,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.024432702786
		},
		"edge": {
			"12": 0.040326,
			"13": 0.136488,
			"14": 0.120978
		},
		"ie_mob": {
			"10": 0.0544067605634,
			"11": 0.221513239437
		},
		"bb": {
			"7": 0.006898,
			"10": null
		},
		"samsung": {
			"0": 3.89737
		},
		"and_uc": {
			"0": 3.669736
		},
		"op_mini": {
			"0": 11.8503919969
		},
		"and_chr": {
			"0": 30.128826
		},
		"and_ff": {
			"0": 0.03449
		}
	},
	"total": 98.804448
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/MR.json
 ** module id = 595
 ** module chunks = 0
 **/